export default __webpack_public_path__ + "static/media/re_arange_icon.14a77304.svg";